import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";

import { getUserHistory } from "../../store/user/user.action";
import ServerPagination from "../../Pages/ServerPagination";

/// Kullanici coin gecmisi — AYVO paneli.
const TYPES = [
  ["call", "Görüşmeler", "fa-phone"],
  ["gift", "Hediyeler", "fa-gift"],
  ["coinPlan", "Satın almalar", "fa-cart-shopping"],
  ["admin", "Admin işlemleri", "fa-user-shield"],
];

const CALL = {
  Outgoing: ["Giden", "#2563EB", "fa-arrow-up-right"],
  Incoming: ["Gelen", "#059669", "fa-arrow-down-left"],
  MissedCall: ["Cevapsız", "#DC2626", "fa-phone-slash"],
};

const UserHistory = () => {
  const { userHistory, totalData, totalCoin } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const id = location.state?.userId;

  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [type, setType] = useState("call");

  useEffect(() => {
    if (id) dispatch(getUserHistory(id, startDate, endDate, activePage, rowsPerPage, type));
  }, [dispatch, id, startDate, endDate, activePage, rowsPerPage, type]);

  const data = userHistory || [];

  const handleApply = (event, picker) => {
    picker.element.val(`${picker.startDate.format("DD.MM.YYYY")} – ${picker.endDate.format("DD.MM.YYYY")}`);
    setStartDate(dayjs(picker.startDate).format("YYYY-MM-DD"));
    setEndDate(dayjs(picker.endDate).format("YYYY-MM-DD"));
    setActivePage(1);
  };

  const handleCancel = (event, picker) => {
    picker?.element.val("");
    setStartDate("");
    setEndDate("");
  };

  const split = (d) => (d ? d.split(",").map((x) => x.trim()) : ["—", ""]);
  const coin = (row) => (
    <span style={{ fontWeight: 700, color: row?.isIncome ? "#059669" : "#DC2626" }}>
      {row?.isIncome ? "+" : "−"}
      {Number(row?.coin || 0).toLocaleString("tr-TR")}
    </span>
  );
  const when = (row) => {
    const [d, t] = split(row?.date);
    return (
      <>
        <div style={{ fontWeight: 600 }}>{d}</div>
        <div style={{ fontSize: 12, color: "var(--badu-sub)" }}>{t}</div>
      </>
    );
  };
  const empty = (n) => (
    <tr>
      <td colSpan={n} className="text-center py-5" style={{ color: "var(--badu-sub)" }}>
        <i className="fa fa-inbox d-block mb-2" style={{ fontSize: 28, opacity: 0.4 }} />
        Bu aralıkta kayıt yok
      </td>
    </tr>
  );

  const th = { fontSize: 12, fontWeight: 700, color: "var(--badu-sub)", textTransform: "none", letterSpacing: 0 };
  const td = { verticalAlign: "middle", fontSize: 13.5, color: "var(--badu-ink)" };

  return (
    <>
      <div className="badu-page-head">
        <div>
          <h4>Coin geçmişi</h4>
          <div className="sub">Kullanıcının görüşme, hediye, satın alma ve admin coin hareketleri</div>
        </div>
        <div>
          <button className="btn btn-outline-primary" onClick={() => history.goBack()}>
            <i className="fa-solid fa-angles-left mr-1" /> Geri
          </button>
        </div>
      </div>

      <div className="badu-tile" style={{ padding: 18 }}>
        <div className="d-flex align-items-center flex-wrap" style={{ gap: 10 }}>
          <div className="d-flex flex-wrap" style={{ gap: 6, background: "var(--badu-line-soft)", padding: 4, borderRadius: 12 }}>
            {TYPES.map(([k, label, icon]) => (
              <button
                key={k}
                onClick={() => {
                  setType(k);
                  setActivePage(1);
                }}
                className="btn btn-sm m-0"
                style={{
                  borderRadius: 9,
                  fontWeight: 600,
                  fontSize: 13,
                  padding: "7px 14px",
                  border: 0,
                  boxShadow: type === k ? "0 1px 3px rgba(0,0,0,.12)" : "none",
                  background: type === k ? "#fff" : "transparent",
                  color: type === k ? "var(--badu-blue)" : "var(--badu-sub)",
                }}
              >
                <i className={`fa ${icon} mr-1`} /> {label}
              </button>
            ))}
          </div>

          <div style={{ flex: 1 }} />

          <DateRangePicker
            initialSettings={{
              autoUpdateInput: false,
              locale: { cancelLabel: "Temizle", applyLabel: "Uygula", format: "DD.MM.YYYY" },
              maxDate: new Date(),
            }}
            onApply={handleApply}
            onCancel={handleCancel}
          >
            <input type="text" className="form-control" placeholder="📅  Tüm tarihler" readOnly style={{ width: 210, cursor: "pointer", background: "#fff", borderRadius: 10 }} />
          </DateRangePicker>

          <div style={{ background: "var(--badu-blue-soft)", borderRadius: 12, padding: "8px 16px", textAlign: "right" }}>
            <div style={{ fontSize: 11.5, color: "var(--badu-sub)", fontWeight: 600 }}>Toplam coin</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: "var(--badu-blue)", lineHeight: 1.1 }}>{Number(totalCoin || 0).toLocaleString("tr-TR")}</div>
          </div>
        </div>

        <div className="table-responsive mt-3">
          <table className="table mb-0">
            <thead>
              {type === "call" && (
                <tr>
                  <th style={th}>Kiminle</th>
                  <th style={th}>Tür</th>
                  <th style={th}>Süre</th>
                  <th style={{ ...th, textAlign: "right" }}>Coin</th>
                  <th style={{ ...th, textAlign: "right" }}>Tarih</th>
                </tr>
              )}
              {type === "gift" && (
                <tr>
                  <th style={th}>Kime</th>
                  <th style={{ ...th, textAlign: "right" }}>Coin</th>
                  <th style={{ ...th, textAlign: "right" }}>Tarih</th>
                </tr>
              )}
              {type === "coinPlan" && (
                <tr>
                  <th style={th}>Paket</th>
                  <th style={th}>Tutar</th>
                  <th style={th}>Ödeme</th>
                  <th style={{ ...th, textAlign: "right" }}>Tarih</th>
                </tr>
              )}
              {type === "admin" && (
                <tr>
                  <th style={th}>İşlem</th>
                  <th style={{ ...th, textAlign: "right" }}>Coin</th>
                  <th style={{ ...th, textAlign: "right" }}>Tarih</th>
                </tr>
              )}
            </thead>
            <tbody>
              {!data.length && empty(5)}

              {type === "call" &&
                data.map((r, i) => {
                  const [label, color, icon] = CALL[r?.callType] || [r?.callType || "—", "var(--badu-sub)", "fa-phone"];
                  const dur = r?.callConnect
                    ? moment.utc(moment(new Date(r.callEndTime)).diff(moment(new Date(r.callStartTime)))).format("HH:mm:ss")
                    : "—";
                  return (
                    <tr key={i}>
                      <td style={{ ...td, fontWeight: 600 }}>@{r?.hostName || "—"}</td>
                      <td style={td}>
                        <span className="badu-chip" style={{ background: `${color}15`, color }}>
                          <i className={`fa ${icon} mr-1`} />
                          {label}
                        </span>
                      </td>
                      <td style={{ ...td, fontVariantNumeric: "tabular-nums" }}>{dur}</td>
                      <td style={{ ...td, textAlign: "right" }}>{coin(r)}</td>
                      <td style={{ ...td, textAlign: "right" }}>{when(r)}</td>
                    </tr>
                  );
                })}

              {type === "gift" &&
                data.map((r, i) => (
                  <tr key={i}>
                    <td style={td}>
                      <i className="fa fa-gift mr-2" style={{ color: "#D97706" }} />
                      <b>@{r?.hostName || "—"}</b>
                    </td>
                    <td style={{ ...td, textAlign: "right" }}>{coin(r)}</td>
                    <td style={{ ...td, textAlign: "right" }}>{when(r)}</td>
                  </tr>
                ))}

              {type === "coinPlan" &&
                data.map((r, i) => (
                  <tr key={i}>
                    <td style={{ ...td, fontWeight: 600 }}>{r?.name || "Coin paketi"}</td>
                    <td style={{ ...td, fontWeight: 700 }}>${r?.dollar ?? "—"}</td>
                    <td style={td}>{r?.paymentGateway || "—"}</td>
                    <td style={{ ...td, textAlign: "right" }}>{r?.createdAt ? dayjs(r.createdAt).format("DD.MM.YYYY HH:mm") : "—"}</td>
                  </tr>
                ))}

              {type === "admin" &&
                data.map((r, i) => (
                  <tr key={i}>
                    <td style={td}>
                      <i className="fa fa-user-shield mr-2" style={{ color: "var(--badu-blue)" }} />
                      {r?.isIncome ? "Admin coin ekledi" : "Admin coin düştü"}
                    </td>
                    <td style={{ ...td, textAlign: "right" }}>{coin(r)}</td>
                    <td style={{ ...td, textAlign: "right" }}>{when(r)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="mt-3">
          <ServerPagination
            activePage={activePage}
            rowsPerPage={rowsPerPage}
            userTotal={totalData}
            handleRowsPerPage={(v) => {
              setRowsPerPage(v);
              setActivePage(1);
            }}
            handlePageChange={setActivePage}
          />
        </div>
      </div>
    </>
  );
};

export default connect(null, { getUserHistory })(UserHistory);
